import { render, staticRenderFns } from "./border-wrap.vue?vue&type=template&id=01bc28b4"
import script from "./border-wrap.vue?vue&type=script&lang=js"
export * from "./border-wrap.vue?vue&type=script&lang=js"
import style0 from "./border-wrap.vue?vue&type=style&index=0&id=01bc28b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports